<template>
    <div class="main">
        <el-dialog
            :close-on-click-modal="false"
            title="支出明显"
            :visible.sync="openData.state"
            width="700px"
            @close="dialogClose"
        >
            <div class="content">
                <div class="box">
                    <el-table :data="tableData" tooltip-effect="dark" style="width: 100%; margin: 15px 0"
                        border ref="multipleTable" height="250" @selection-change="handleSelectionChange"
                    >
                        <el-table-column type="index" width="50" label="序号" align="center">
                        </el-table-column>
                        <el-table-column prop="spendingTime" label="时间" align="center">
                        </el-table-column>
                        <el-table-column  prop="applicantOrganisation" label="申请机构" align="center">
                        </el-table-column>
                        <el-table-column  prop="proposer" label="申请人" align="center">
                        </el-table-column>
                        <el-table-column prop="appliedAmount" label="申请金额" align="center">
                        </el-table-column>
                        <!-- <el-table-column label="操作" align="center"  width="200px" fixed="right">
                            <template slot-scope="scope">
                                <span @click="handleTableForm('', scope.row)"  style="margin-right: 12px; 
                                    cursor: pointer" >编辑</span>
                                <span @click="deleteItem(scope.row)" style="margin-right: 12px; cursor:
                                    pointer">删除</span >
                            </template>
                        </el-table-column> -->
                    </el-table>
                    <el-pagination
                        align="center"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pageSize"
                        :current-page.sync="pageNo"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                        @size-change="handletableDataSize"
                        @current-change="handleTableDataChange"
                    ></el-pagination>
                </div>
            </div>
            <div class="footer">
                <el-button type="primary" @click="save" :loading="saveLoading"
                    >确 定</el-button
                >
                <el-button @click="dialogClose">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: ["openData"],
    data() {
        return {
            saveLoading: false,
            searchLoading: false,
            pageSize: 10,
            pageNo: 1,
            total: 0,
            chooseIds: [],
            tableData: [],
            name: "",
            phone: "",
            isSearchContent: true,
        }
    },
    created() {
        this.getList(row)
        this.chooseIds = []
    },

    methods: {
        // 操作方法
        handleTableForm(title, row) {},
        // 搜搜
        searchList() {
            this.getList()
        },
        // 人员选择
        handleSelectionChange(rows) {
            if (rows) {
                rows.forEach((row, index) => {
                    this.chooseIds.push(row.id)
                })
            }
        },
        // 获取表格数据
        getList(row) {
            let params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                id:row.id
            }
            this.$http
                .request({
                    url: "/ypt/admin/serviceFund/info/findListFund",
                    method: "POST",
                    data: params,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.tableData = []
                            this.total = 0
                            return
                        }
                        this.tableData = []
                        this.tableData = res.content.list
                        this.total = res.content.count
                    }
                })
        },
        // 页面大小
        handletableDataSize(val) {
            this.pageSize = val
            this.getList()
        },
        // 当前页
        handleTableDataChange(val) {
            this.pageNo = val
            this.getList()
        },
        // 清空
        clearData() {
            this.pageSize = 10
            this.pageNo = 1
            this.total = 0
            this.name = ""
            this.phone = ""
            this.tableData = []
            this.chooseIds = []
            this.$refs.multipleTable.clearSelection()
            this.getList()
        },
        // 保存信息
        save() {
            if (this.chooseIds.length > 0) {
                let params = {
                    communityWorkerIds: this.chooseIds,
                    socialOrgId: this.openData.socialOrgId,
                }
                this.$http
                    .request({
                        url: "/ypt/admin/communityWorker/info/insertBySocialOrg",
                        method: "POST",
                        data: params,
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            this.$message.warning(res.message)
                            this.chooseIds = []
                            this.dialogClose()
                        } else {
                            this.$message.warning(res.message)
                            this.chooseIds = []
                        }
                    })
            } else {
                this.$message.warning("请先选择人员")
            }
        },
        // 关闭人员信息
        dialogClose() {
            this.openData.state = false
            this.clearData()
            this.$emit("canclePerson", false)
        },
    },
}
</script>
<style lang="less" scoped>
.content {
    border-top: 1px solid #eee;
}
.footer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
}
/deep/ .search_wrapper {
    display: flex;
    flex-direction: column;
    position: relative;
    .search_head {
        background: #e6e6e6;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        color: rgb(0, 0, 0);
        border-color: rgb(217, 217, 217);
        padding: 6px 15px;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
    }
    .search_content {
        padding: 42px 20px 20px 20px;
        border: 1px solid rgb(217, 217, 217);
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
    .search_inline {
        width: 100%;
    }
    .arrowDown1 {
        width: 28px;
        height: 28px;
        background: #edf2f0;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 50%;
        bottom: -14px;
        transform: translate(-50%, 0px);
        border-radius: 50%;
        z-index: 2;
        cursor: pointer;
    }
    .el-icon-arrow-up {
        &::before {
            color: #000;
            font-size: 18px;
        }
    }
}
.box {
    margin: 25px 0;
}
</style>